module.exports = __webpack_public_path__ + "img/background-54.f5391d6c.png";